module.exports = __webpack_public_path__ + "img/534a0c883ab926c4f36457a4fb08ddf1.png";